import { YStack, XStack, Text } from 'tamagui'
import type { CTASlide as CTASlideType } from '../../../content/decks/types'
import { SlideContainer, SlideInner, getAccentColor, getAccentGlow, parseLinkedText } from './shared'

function LinkButton({ href, label, accentColor, glow }: { href: string; label: string; accentColor: string; glow: string }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'inline-flex',
        paddingInline: '24px',
        paddingBlock: '12px',
        borderRadius: '12px',
        border: `1px solid ${accentColor}`,
        textDecoration: 'none',
        cursor: 'pointer',
        pointerEvents: 'auto',
        position: 'relative',
        zIndex: 10,
        fontFamily: 'Inconsolata, monospace',
        fontSize: 'clamp(14px, 1.8vw, 22px)',
        color: accentColor,
        textShadow: glow,
      }}
    >
      {label}
    </a>
  )
}

export function CTASlide({ slide }: { slide: CTASlideType }) {
  const accentColor = getAccentColor(slide.accent)
  const glow = getAccentGlow(slide.accent)
  return (
    <SlideContainer>
      <SlideInner alignItems="center" style={{ padding: 'clamp(32px, 6vw, 80px)' }}>
        <Text
          fontFamily="$heading"
          fontWeight="700"
          color={accentColor}
          textAlign="center"
          style={{ fontSize: 'clamp(28px, 4vw, 56px)', lineHeight: '1.2em' }}
        >
          {slide.headline}
        </Text>
        {slide.body && (
          <Text
            fontFamily="$body"
            color="$textSecondary"
            textAlign="center"
            style={{ fontSize: 'clamp(14px, 1.8vw, 22px)', maxWidth: '700px', lineHeight: '1.5em' }}
          >
            {parseLinkedText(slide.body)}
          </Text>
        )}
        <XStack gap="$4" marginTop="$6" flexWrap="wrap" justifyContent="center">
          <LinkButton href={slide.href} label={slide.linkText} accentColor={accentColor} glow={glow} />
          {slide.links?.map((link, i) => (
            <LinkButton key={i} href={link.href} label={link.text} accentColor={accentColor} glow={glow} />
          ))}
        </XStack>
      </SlideInner>
    </SlideContainer>
  )
}
